import { cloneDeepWith } from './cloneDeepWith.mjs';

function cloneDeep(obj) {
    return cloneDeepWith(obj);
}

export { cloneDeep };
